module.exports = __webpack_public_path__ + "img/d.006c3837.jpg";